module.exports = __webpack_public_path__ + "static/media/bg5.26c75f1d.jpg";